var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"rounded-0 hero-pg-img",attrs:{"src":"https://zebuetrade.com/asset/static/img/apppromo.png","width":"100%"}})])
}]

export { render, staticRenderFns }